<template>
  <footer>
    <div class="box-accesos">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 hidden-xs hidden-sm">
            <div class="logo">
              <a href="http://www.cace.org.ar/selloscybermonday" target="_blank">
                <img src="/static/img/app/sello-oficial.png" style="width:120px;" border="0">
              </a>
            </div>
          </div>

          <div class="col-lg-3">
            <ul>
              <li>CONTACTANOS.</li>
              <li>E-mail. <a href="mailto:mayoristas@gorsh.com">mayoristas@gorsh.com</a></li>
              <li>WhatsApp. +54911 2157 8721</li>
            </ul>
          </div>
          <!--
            <div class="col-lg-3">
                <ul>
                    <li>GORSH STORE</li>
                    <li>Lun. a Sáb. de 10 a 20hs</li>
                    <li>El Salvador 6029, Palermo.</li>
                    <li>CABA, Argentina.</li>
                </ul>
            </div>
            -->
          <div class="col-lg-3">
            <ul>
              <li>SEGUINOS.</li>
              <li><a href="https://facebook.com/gorshcom/" target="_blank"><i class="fa fa-facebook"></i> &nbsp; Facebook</a></li>
              <li><a href="https://instagram.com/gorshcom/" target="_blank"><i class="fa fa-instagram"></i> &nbsp; Instagram</a></li>
              <li><a href="https://twitter.com/gorshcom/" target="_blank"><i class="fa fa-twitter"></i> &nbsp; Twitter</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="box-certificados">
      <div class="container">

        <ul>
          <li><a href="javascript:;"><img src="/static/img/app/logo-badistrito.png"></a></li>
          <li><a href="javascript:;"><img src="/static/img/app/logo-cmd.png"></a></li>
          <li><a href="javascript:;"><img src="/static/img/app/logo-cace.png"></a></li>
          <li><a href="javascript:;"><img src="/static/img/app/logo-secure.png"></a></li>
          <li><a href="http://qr.afip.gob.ar/?qr=hyIDZhBmVSCAyvB1yQLj1g,,"  target="_F960AFIPInfo"><img src="/static/img/app/logo-afip.png"></a></li>
          <li><a href="https://kid.agency/?r=GorshMayoristas" target="_blank"><img src="https://kid.agency/_external/siteby.light.svg"></a></li>
        </ul>
        <div class="clear"></div>

      </div>
    </div>
  </footer>

</template>

<script>
    export default {
        name: "FooterPartial"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FooterPartial.vue